<template>
  <span id="add-cutoff-group" v-if="$can(permissions.WAREHOUSE.EDIT_SHIPPER_CUTOFF_GROUP)">
    <cutoff-group-detail-dialog ref="cutoffGroupDetailDialog" class="cutoff-group-detail-dialog-internal" :shipper-cutoff-group-id="cutoffGroupSaved.id" :name="cutoffGroupSaved.name" :number-of-shippers="cutoffGroupSaved.numberOfShippers" />
    <el-button
      id="add-cutoff-group-button"
      class="button-action-default add-cutoff-group-margin-bottom"
      size="mini"
      type="success"
      plain
      @click="dialogVisible = true"
    >{{ $t('shipperCutoffGroup.add') }}</el-button>

    <el-dialog
        id="add-cutoff-group-dialog"
        v-on:open="handleOpen"
        :title="$t('shipperCutoffGroup.add')"
        :visible.sync="dialogVisible"
        width="35%"
        class="dialog-with-cols"
        append-to-body
        :close-on-click-modal="false"
    >
      <el-form
        :model="form"
        :rules="formRules"
        ref="form"
        label-position="right"
        class="form-vertical-item"
        label-width="160px"
        size="mini"
        @submit.native.prevent
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('shipperCutoffGroup.cutoffGroupName')" prop="name">
               <el-input
                  v-model="form.name"
                  v-alphanumeric-validation
                  maxlength="35"
                  clearable
                  v-on:keyup.enter.native="submitForm"
                  class="inline-input"
                  id="form-group-name"
                  ref="formGroupName"
                  ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
          id="add-cutoff-group-dialog-footer"
          slot="footer"
          class="dialog-footer form-vertical-item flex-reverse-direction"
      >
        <el-button
            type="primary"
            id="add-cutoff-button-submit"
            @click="submitForm()"
            size="mini"
        >{{ $t('shipperCutoffGroup.add') }}</el-button>
        <el-button
            id="add-cutoff-button-refresh"
            @click="resetForm()"
            size="mini"
        >{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import { SHIPPER_CUTOFF_GROUP_SAVE, SHIPPER_CUTOFF_GROUP_SEARCH } from '@/store/actions';
import constants from '@/utils/constants';
import CutoffGroupDetailDialog from './CutoffGroupDetailDialog';

export default {
  name: 'AddCutoffGroup',
  components: {
    CutoffGroupDetailDialog
  },
  props: {
    name: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
      },
      formRules: {
        name: [
          {
            required: true,
            message: this.$t('shipperCutoffGroup.cutoffGroupNameRequired'),
            trigger: 'blur'
          }
        ]
      },
      cutoffGroupSaved: {
        id: 0,
        name: '',
        numberOfShippers: 0
      }
    };
  },
  methods: {
    async handleOpen() {
      await this.resetForm();
    },
    async submitForm() {
      const validForm = await this.$refs.form.validate().catch(() => {});
      if (!validForm) {
        return;
      }

      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);

      try {
        const response = await this.$store.dispatch(SHIPPER_CUTOFF_GROUP_SAVE, this.form.name);
        this.$message.success(response.message);
        if (response.data) {
          this.cutoffGroupSaved.id = response.data.id;
          this.cutoffGroupSaved.name = response.data.name;
        }
        this.dialogVisible = false;
        this.$nextTick(() => {
          this.$refs.cutoffGroupDetailDialog.handleOpenDialog();
        });
        this.$store.dispatch(SHIPPER_CUTOFF_GROUP_SEARCH, {});
      } finally {
        loading.close();
      }
    },
    async resetForm() {
      await this.$nextTick();
      this.cutoffGroupSaved = {
        id: 0,
        name: '',
        numberOfShippers: 0
      };
      this.$refs.form.resetFields();
      this.$refs.form.$el[0].focus();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
#add-cutoff-group {
  .cutoff-group-detail-dialog-internal {
    #btn-cutoff-group-detail-dialog {
      display: none;
    }
  }
}
.add-cutoff-group-bottom {
  float: right;
}
</style>
